import { computed } from 'vue';

/**
 * 站点配置相关的 composable
 * @returns {Object} 返回站点配置相关的计算属性和方法
 */
export default function useSiteConfig() {
    /**
     * 判断是否不限制站点名称宽度
     * @周梦君(周梦君) 要求这个站点不要限制宽度
     * @returns {ComputedRef<boolean>} 返回 true 表示不限制宽度，false 表示限制为 280px
     */
    const hasNoLimit = computed(() => {
        //  zjxh
        return window.location.host.includes('zjxh');
    });

    return {
        hasNoLimit
    };
}
